/**
 * Shared class names for Artmosphere cream/gold buttons (see artmosphereButtonTheme.css).
 */

export const artBtnPrimary = 'art-btn-primary';
export const artBtnSecondary = 'art-btn-secondary';
export const artBtnCard = 'art-btn-card';
export const artBtnNavPill = 'art-btn-nav-pill';
export const artBtnNavCta = 'art-btn-nav-cta';

/** Compact header pill — Login, Home, Artist Corner, Sign out */
export const artNavPillBtn =
  `${artBtnNavPill} inline-flex items-center justify-center gap-1.5 rounded-full px-2.5 py-1.5 text-[11px] font-medium shadow-[0_4px_14px_rgba(120,72,20,0.06)] sm:px-3 sm:py-2 sm:text-xs`;

/** Header primary — Join Community */
export const artNavCtaBtn =
  `${artBtnNavCta} inline-flex items-center justify-center gap-1.5 rounded-full px-2.5 py-1.5 text-[11px] font-semibold shadow-[0_4px_14px_rgba(120,72,20,0.08)] sm:px-3 sm:py-2 sm:text-xs`;

/** Standard primary action */
export const artPrimaryBtn =
  `${artBtnPrimary} rounded-full font-semibold transition`;

export const artPrimaryBtnLg =
  `${artBtnPrimary} rounded-xl font-semibold transition px-6 py-3`;

export const artSecondaryBtn =
  `${artBtnSecondary} rounded-full font-medium transition`;

export const artSecondaryBtnLg =
  `${artBtnSecondary} rounded-lg font-medium transition px-6 py-3`;
